<script setup lang="ts">
import { getMobileDevice } from "@shared/IsMobile";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { signupData } from "../data";
import { useRoute } from "vue-router";

defineEmits(["stepComplete", "stepLoading"]);
const isAppleDevice = ref(getMobileDevice().apple.device);
const { locale } = useI18n();
const badgeUrl = computed(
  () =>
    `/assets/overlay/marketing/${
      isAppleDevice.value ? "app-store" : "google-play"
    }-badge-${locale.value}.svg`,
);
function isTiktok(): boolean {
  const query = useRoute().query;
  if (query["utm_source"] == "tiktok") {
    return true;
  }
  if (query["utm_campaign"] == "tiktok") {
    return true;
  }
  return false;
}

const targetUrl = isTiktok()
  ? "https://app.adjust.com/12rsjchy"
  : "https://bithotel.io/app";
</script>
<template>
  <iframe src="/completeregistration.html"></iframe>
  <div
    v-depixel
    class="flex vertical center gap--m font--sm padding-t--ml padding-b--s"
  >
    {{
      $t("pages.signup.download.welcome-user", { user: signupData.username })
    }}

    <span v-depixel-normal class="font--s">
      {{
        $t("pages.signup.download.download-store", {
          store: isAppleDevice ? "App" : "Play",
        })
      }}
    </span>
    <a class="width--full" :href="targetUrl" target="_self">
      <img
        class="width--full"
        :src="badgeUrl"
        :alt="isAppleDevice ? 'App' : 'Play' + ' store badge'"
      />
    </a>
  </div>
</template>
<style scoped lang="scss">
a {
  height: 86px;
  max-width: 100%;
  object {
    height: 100%;
  }
}
</style>
